import React from 'react';

const ProgressBar = ({ value, max = 100, color = "blue", label, sublabel, animated = true }) => {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));
  
  const colorClasses = {
    blue: "bg-blue-500", green: "bg-green-500", yellow: "bg-yellow-500",
    red: "bg-red-500", orange: "bg-orange-500", purple: "bg-purple-500"
  };

  return (
    <div className="w-full">
      {(label || sublabel) && (
        <div className="flex justify-between text-sm mb-1.5">
          <span className="font-medium text-gray-700">{label}</span>
          <span className="text-gray-500">{sublabel}</span>
        </div>
      )}
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div 
          className={`${colorClasses[color]} h-3 rounded-full ${animated ? 'transition-all duration-700 ease-out' : ''}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;